package repositories

import practicetest.SubjectResponse

class MainMenuRepositoryException(val networkError: Boolean) : Exception()

interface SubjectRepository {
    suspend fun subjects(): Result<SubjectResponse>
}